import React from 'react';
import styled from 'styled-components';

import { Badge } from '@companycam/slab-web';
import { translate } from 'translations/i18n';

import type { PaymentRequestStatus } from './types';

type PaymentRequestStatusBadgeProps = {
  status: PaymentRequestStatus;
};

const badgeLabel = (status: PaymentRequestStatus) => {
  switch (status) {
    case 'failed':
      return translate('paymentRequestStatusBadge.status.failedLabel');

    case 'shared':
      return translate('paymentRequestStatusBadge.status.sharedLabel');

    case 'draft':
      return translate('paymentRequestStatusBadge.status.draftLabel');

    case 'refunded':
      return translate('paymentRequestStatusBadge.status.refundedLabel');

    case 'refund_pending':
      return translate('paymentRequestStatusBadge.status.refundPendingLabel');

    case 'paid':
      return translate('paymentRequestStatusBadge.status.paidLabel');

    default:
      return translate('paymentRequestStatusBadge.status.processingLabel');
  }
};

const badgeColorFor = (status: PaymentRequestStatus) => {
  switch (status) {
    case 'draft':
      return 'info';

    case 'shared':
      return 'caution';

    case 'failed':
      return 'destroy';

    default:
      return 'success';
  }
};

const RefundBadge = styled(Badge)`
  && {
    background-color: #ffedd5;
    border: var(--cc_size_border_width_s) solid #fb923c;
  }
`;

const PaymentRequestStatusBadge = ({
  status,
}: PaymentRequestStatusBadgeProps) => {
  const isRefundingStatus = ['refunded', 'refund_pending'].includes(status);
  const label = badgeLabel(status);

  return isRefundingStatus ? (
    <RefundBadge>{label}</RefundBadge>
  ) : (
    <Badge color={badgeColorFor(status)}>{label}</Badge>
  );
};

export default PaymentRequestStatusBadge;
